<template>
  <div class="columns is-mobile is-vcentered">
    <div class="column is-2 is-size-7-mobile">
      <router-link v-if="sectionNumber > 1" :to="getPath(sectionNumber - 1)">
        &lt; <span class="is-hidden-mobile">Previous</span>
      </router-link>
    </div>
    <div class="column is-8 has-text-centered">
      <p class="has-text-weight-bold">{{ bookName }}</p>
      <p class="is-size-7">
        {{ sectionNumber }} of {{ sectionTotal }}
        <goto
          class="is-size-7 goto"
          :bookId="bookId"
          :defaultValue="sectionNumber"
          :max="sectionTotal"
        />
      </p>
    </div>
    <div class="column is-2 is-size-7-mobile has-text-right">
      <router-link
        v-if="sectionNumber < sectionTotal"
        :to="getPath(sectionNumber + 1)"
      >
        <span class="is-hidden-mobile">Next</span> &gt;
      </router-link>
    </div>
  </div>
</template>

<script>
import Goto from "@/components/Goto";
import routeMixin from "@/mixins/routeMixin";
export default {
  props: ["bookId", "bookName", "sectionNumber", "sectionTotal"],
  components: { Goto },
  mixins: [routeMixin],
  methods: {
    getPath(sectionNumber) {
      return this.getSectionPath(this.bookId, sectionNumber);
    }
  }
};
</script>

<style lang="scss" scoped>
.goto {
  padding-left: 5px;
}
</style>
